// Mensagens de erro traduzidas, iguais no celular e no navegador.
import { t } from './i18n';

export function traduzErro(e: unknown): string {
  const msg = String((e as any)?.message ?? e ?? '');
  const m = msg.toLowerCase();
  if (m.includes('invalid login')) return t('CPF ou senha incorretos.');
  if (m.includes('already registered') || m.includes('already been registered') || m.includes('perfis_cpf_key') || m.includes('database error saving new user')) return t('Este CPF já tem cadastro. Use "Entrar".');
  if (m.includes('password') && m.includes('6')) return t('A senha precisa ter pelo menos 8 caracteres.');
  if (m.includes('email not confirmed')) return t('Cadastro aguardando liberação: desligue "Confirm email" no Supabase (veja COMO RODAR).');
  if (m.includes('unable to validate email') || m.includes('invalid email')) return t('E-mail inválido.');
  if (m.includes('rate limit')) return t('Muitas tentativas. Aguarde alguns minutos.');
  if (m.includes('network') || m.includes('fetch')) return t('Sem conexão com o servidor. Confira a internet.');
  if (m.includes('planner_dados') && m.includes('does not exist')) return t('O banco ainda não foi preparado. Rode o arquivo supabase/schema.sql no Supabase.');
  return t('Não deu certo: {msg}', { msg });
}
